import React, { Component } from 'react';
import { Route, Switch, Redirect } from 'react-router-dom';
import { observer, inject } from 'mobx-react';
import TagManager from 'react-gtm-module';

import 'services/fontAwesome';

import { Layout } from 'common/components/Layout/Layout';

import {
  ANCHOR,
  GOOGLE,
  EXTERNAL_LINK,
  SURVEY_ANCHOR
} from 'common/consts/common';
import LocationObserver from 'common/components/LocationObserver/LocationObserver';

import Home from 'views/Home/Home';
import CompaniesView from 'views/Companies/CompaniesView';
import TeamOfExperts from 'views/TeamOfExperts/TeamOfExpertsView';
import MissionAndVisionView from 'views/MissionAndVision/MissionAndVisionView';
import SimpleCaseStudyView from './views/SimpleCaseStudy/SimpleCaseStudy';
// "this is disabled, because there is a new concept of case studies. The old one has been disabled"
// import CaseStudiesView from 'views/CaseStudies/CaseStudiesView';
// import CaseStudiesListingView from 'views/CaseStudiesListing/CaseStudiesListingView';
import PressRoomListingView from 'views/PressRoomListing/PressRoomListingView';
import PressRoomArticleView from 'views/PressRoomArticle/PressRoomArticleView';
import NewsArticleView from 'views/News/NewsArticleView';
import NewsListView from 'views/News/NewsListView';
import JobOfferArticleView from 'views/JobOfferArticle/JobOfferArticleView';
import JobOffersView from 'views/JobOffers/JobOffersView';
import Contact from 'views/Contact/Contact';
import AuthoritiesView from 'views/Authorities/AuthoritiesView';
import CSRView from 'views/CSR/CSRView';
import MediaAboutUsView from 'views/MediaAboutUs/MediaAboutUsView';
import StrategyView from 'views/Strategy/StrategyView';
import SynergyView from 'views/Synergy/SynergyView';
import HistoryView from 'views/History/HistoryView';
import CurrentReportsView from 'views/CurrentReports/CurrentReportsView';
import CurrentReportView from './views/CurrentReport/CurrentReportView';
import ForInvestors from 'views/ForInvestors/ForInvestors';
import ReportsView from 'views/Reports/ReportsView';
import CorporateGovernance from 'views/CorporateGovernance/CorporateGovernanceView';
import Announcement from 'views/Announcement/AnnouncementView';
import IssueOfShares from 'views/IssueOfShares/IssueOfSharesView';
import ChoosenCompanyView from 'views/ChoosenCompany/ChoosenCompanyView';
import TermsOfUse from 'views/TermsOfUse/TermsOfUse';
import InfoAboutCompany from 'views/InfoAboutCompany/InfoAboutCompanyView';
import PageNotFound from 'views/PageNotFound/PageNotFoundView';
import ShareholdersView from 'views/Shareholders/ShareholdersView';
import GeneralMeetings from 'views/GeneralMeetings/GeneralMeetingsView';
import GeneralMeeting from 'views/GeneralMeeting/GeneralMeetingView';
import PlannedEvents from 'views/PlannedEvents/PlannedEvents';
import InformationClause from 'views/InformationClause/InformationClause';
import RodoPolicyView from './views/RodoPolicy/RodoPolicyView';
import Whistleblowing from './views/Whistleblowing/Whistleblowing';
import ZszPolicyView from './views/ZszPolicy/ZszPolicyView';

import PresentationsListView from './views/Presentations/PresentationsListView';

import ContentStore from 'stores/Content.store';
import LanguageService from 'services/Language.service';

const hasGTMID = !!GOOGLE.TAG_MANAGER_ID;
const tagManagerArgs = {
  gtmId: GOOGLE.TAG_MANAGER_ID
};

if (hasGTMID) TagManager.initialize(tagManagerArgs);

@inject('ContentStore')
@observer
class App extends Component {
  overflowUnsetArray = [ANCHOR.FOR_INVESTORS];

  componentDidMount() {
    ContentStore.fetchContent();
  }

  render() {
    const {
      props: { match }
    } = this;
    const language = LanguageService.getLang();
    const localizedPath = path => `${match.path}${path}`;
    const overflowUnset = this.overflowUnsetArray.some(
      el => el[language] === window.location.pathname
    );

    return (
      <>
        {ContentStore.content ? (
          <LocationObserver>
            <Layout overflowUnset={overflowUnset}>
              <Switch>
                <Route
                  path={localizedPath(ANCHOR.HOME[language])}
                  exact
                  component={Home}
                />
                <Route
                  path={localizedPath(ANCHOR.MISSIONANDVISION[language])}
                  exact
                  component={MissionAndVisionView}
                />
                <Route
                  path={localizedPath(ANCHOR.TEAMOFEXPERTS[language])}
                  exact
                  component={TeamOfExperts}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.MEDIAABOUTUS[language]}/:category?`
                  )}
                  exact
                  component={MediaAboutUsView}
                />
                <Route
                  path={localizedPath(ANCHOR.CSR[language])}
                  exact
                  component={CSRView}
                />
                <Route
                  path={localizedPath(ANCHOR.STRATEGY[language])}
                  exact
                  component={StrategyView}
                />
                <Route
                  path={localizedPath(ANCHOR.SYNERGY[language])}
                  exact
                  component={SynergyView}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.CASESTUDIES[language]}/:category?`
                  )}
                  exact
                  component={SimpleCaseStudyView}
                />
                {/* "this is disabled, because there is a new concept of case studies. The old one has been disabled"
              <Route
                path={localizedPath(`${ANCHOR.CASESTUDIES[language]}/:slug`)}
                exact
                component={CaseStudiesView}
              />
              <Route
                path={localizedPath(ANCHOR.CASESTUDIES[language])}
                exact
                component={CaseStudiesListingView}
              /> */}
                <Route
                  path={localizedPath(
                    `${ANCHOR.NEWS[language]}/:category/:slug`
                  )}
                  exact
                  component={NewsArticleView}
                />
                <Route
                  path={localizedPath(`${ANCHOR.NEWS[language]}/:category?`)}
                  exact
                  component={NewsListView}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.PRESSROOM[language]}/:category/:slug`
                  )}
                  exact
                  component={PressRoomArticleView}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.PRESSROOM[language]}/:category?`
                  )}
                  exact
                  component={PressRoomListingView}
                />
                <Route
                  path={localizedPath(`${ANCHOR.JOBOFFERS[language]}/:slug`)}
                  exact
                  component={JobOfferArticleView}
                />
                <Route
                  path={localizedPath(ANCHOR.JOBOFFERS[language])}
                  exact
                  component={JobOffersView}
                />
                <Route
                  path={localizedPath(ANCHOR.CONTACT[language])}
                  exact
                  component={Contact}
                />
                <Route
                  path={localizedPath(ANCHOR.AUTHORITIES[language])}
                  exact
                  component={AuthoritiesView}
                />
                <Route
                  path={localizedPath(ANCHOR.HISTORY[language])}
                  exact
                  component={HistoryView}
                />
                <Route
                  path={localizedPath(ANCHOR.REPORTS[language])}
                  exact
                  component={ReportsView}
                />
                <Route
                  path={localizedPath(ANCHOR.CORPORATEGOVERNANCE[language])}
                  exact
                  component={CorporateGovernance}
                />
                <Route
                  path={localizedPath(ANCHOR.ISSUE_OF_SHARES[language])}
                  exact
                  component={IssueOfShares}
                />
                <Route
                  path={localizedPath(`${ANCHOR.COMPANIES[language]}/:slug`)}
                  exact
                  component={ChoosenCompanyView}
                />
                <Route
                  path={localizedPath(
                    `${match.path}${ANCHOR.COMPANIES[language]}`
                  )}
                  exact
                  component={CompaniesView}
                />
                <Route
                  path={localizedPath(ANCHOR.TERMS_OF_USE[language])}
                  exact
                  component={TermsOfUse}
                />
                <Route
                  path={localizedPath(ANCHOR.FOR_INVESTORS[language])}
                  exact
                  component={ForInvestors}
                />
                <Route
                  path={localizedPath(ANCHOR.CURRENT_REPORTS[language])}
                  exact
                  component={CurrentReportsView}
                />
                <Route
                  path={localizedPath(ANCHOR.PRESENTATIONS[language])}
                  exact
                  component={PresentationsListView}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.CURRENT_REPORTS[language]}/:category`
                  )}
                  exact
                  component={CurrentReportsView}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.CURRENT_REPORTS[language]}/:category/:slug`
                  )}
                  exact
                  component={CurrentReportView}
                />
                <Route
                  path={localizedPath(ANCHOR.SHAREHOLDERS[language])}
                  exact
                  component={ShareholdersView}
                />
                <Route
                  path={localizedPath(ANCHOR.INFO_ABOUT_COMPANY[language])}
                  exact
                  component={InfoAboutCompany}
                />
                <Route
                  path={localizedPath(ANCHOR.PLANNED_EVENTS[language])}
                  exact
                  component={PlannedEvents}
                />
                <Route
                  path={localizedPath(ANCHOR.GENERAL_MEETINGS[language])}
                  exact
                  component={GeneralMeetings}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.GENERAL_MEETINGS[language]}/:category`
                  )}
                  exact
                  component={GeneralMeetings}
                />
                <Route
                  path={localizedPath(
                    `${ANCHOR.GENERAL_MEETINGS[language]}/:category/:slug`
                  )}
                  exact
                  component={GeneralMeeting}
                />
                <Route
                  path={localizedPath(`${ANCHOR.RODO_POLICY[language]}`)}
                  exact
                  component={RodoPolicyView}
                />
                <Route
                  path={localizedPath(`${ANCHOR.ZSZ_POLICY[language]}`)}
                  exact
                  component={ZszPolicyView}
                />
                {ContentStore.content &&
                  ContentStore.content.landingPageJobOffers &&
                  ContentStore.content.landingPageJobOffers.map(lp => (
                    <Redirect
                      key={lp.id}
                      from={lp.slug}
                      to={{
                        pathname: localizedPath(ANCHOR.JOBOFFERS[language]),
                        state: { background: lp.image }
                      }}
                    />
                  ))}
                <Route
                  path={localizedPath(SURVEY_ANCHOR.INFORMATION_CLAUSE)}
                  exact
                  component={InformationClause}
                />
                <Route
                  path={localizedPath(SURVEY_ANCHOR.SATISFACTION_SURVEY)}
                  exact
                  component={() =>
                    (window.location.href = EXTERNAL_LINK.SATISFACTION_SURVEY)
                  }
                />
                <Route
                  path={localizedPath(`${ANCHOR.WHISTLEBLOWING[language]}`)}
                  exact
                  component={Whistleblowing}
                />
                <Route
                  path={localizedPath(`${ANCHOR.ANNOUNCEMENT[language]}`)}
                  exact
                  component={Announcement}
                />
                <Route component={PageNotFound} />
              </Switch>
            </Layout>
          </LocationObserver>
        ) : (
          <span>Loading...</span>
        )}
      </>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js